module.exports = __webpack_public_path__ + "static/media/IntroToOpenSource.a5c4488d.png";